<script setup>
import { computed, onMounted, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import { useAlert } from 'dashboard/composables';

const props = defineProps({
  conversationId: { type: Number, required: true },
});

const { t } = useI18n();
const store = useStore();

const setting = computed(() =>
  store.getters['conversationBot/getConversationBotSetting'](
    props.conversationId
  )
);
const botEnabled = computed(() => setting.value?.bot_enabled ?? false);
const agentTakeover = computed(() => setting.value?.agent_takeover ?? false);

async function load() {
  await store.dispatch(
    'conversationBot/fetchConversationSetting',
    props.conversationId
  );
}

async function toggle() {
  if (agentTakeover.value) return;
  await store.dispatch('conversationBot/updateConversationSetting', {
    conversationId: props.conversationId,
    bot_enabled: !botEnabled.value,
  });
  useAlert(t('MINISTRY.BOT_PANEL.TOGGLE_SUCCESS'));
}

watch(() => props.conversationId, load);
onMounted(load);
</script>

<template>
  <button
    v-if="setting"
    class="flex items-center gap-1 px-2 py-1 rounded-full text-[10px] font-medium transition-colors"
    :class="
      agentTakeover
        ? 'bg-n-slate-3 text-n-slate-7 cursor-default'
        : botEnabled
          ? 'bg-woot-50 text-woot-600 hover:bg-woot-100 border border-woot-200'
          : 'bg-n-slate-3 text-n-slate-7 hover:bg-n-slate-4 border border-n-weak'
    "
    :title="
      botEnabled
        ? t('MINISTRY.BOT_PANEL.DISABLE')
        : t('MINISTRY.BOT_PANEL.ENABLE')
    "
    @click="toggle"
  >
    <span class="i-lucide-bot size-3" />
    {{
      botEnabled
        ? t('MINISTRY.BOT_PANEL.BOT_ACTIVE')
        : t('MINISTRY.BOT_PANEL.BOT_OFF')
    }}
  </button>
</template>
